// Combo's family lib. Every mode it offers draws the drill-down levels themselves, so none of them
// depends on a tag universe the way the rest of the family's do - which is why the view-mode heal
// is declined here and the options are filtered by nothing but the question's own list.

import {
  OE_PRESET_OPTIONS,
  getKey,
  getQuestionCodeBooks,
  getQuestionSentiments,
  getQuestionTags
} from '@aytm/app/stats/page/question-views/oe/lib/family'

export const CX_VIEW_MODES_OPTIONS = [
  { key: 'sunburst', text: 'Donut chart' },
  { key: 'treemap', text: 'Nested Area chart' },
  { key: 'wordcloud', text: 'Wordcloud' }
]

// a single-level combo has no nesting to draw, so it plots one plain chart instead
export const SCX_VIEW_MODES_OPTIONS = [
  { key: 'chart', text: 'Chart' },
  { key: 'wordcloud', text: 'Wordcloud' }
]

const isSingleLevel = type => 'scx' === type

export const CX_FAMILY_LIB = {
  viewModesOptions: CX_VIEW_MODES_OPTIONS,
  presetOptions: OE_PRESET_OPTIONS,
  defaultConfig: {},
  getKey,
  getQuestionCodeBooks,
  getQuestionTags,
  getQuestionSentiments,
  getViewModesOptions: (key, type, { viewModes } = {}) =>
    (isSingleLevel(type) ? SCX_VIEW_MODES_OPTIONS : CX_VIEW_MODES_OPTIONS).filter(v =>
      0 < viewModes?.length ? viewModes.includes(v.key) : true
    ),
  getDefaultViewMode: (key, type, { viewMode } = {}) => {
    if (null != viewMode) return viewMode

    return isSingleLevel(type) ? 'chart' : 'sunburst'
  }
}
